import Vue from 'vue'
import {ActionTree, MutationTree, GetterTree} from 'vuex'
import {RootState} from '@/store/types'
import VueI18n from '../../helpers/i18n';
import store from '@/store'

import axios from 'axios';
import router from "@/router";
import api from "@/service/api";

export interface Tokens {
    access_token: string | null
    refresh_token: string | null
}

export interface State {
    isRefresh: any,
    tokens: Tokens,
    registrationRequired: boolean,
    registrationError: string,
    registrationSuccess: boolean,
}

const defaultState: State = {
    isRefresh: false,
    tokens: {
        access_token: null,
        refresh_token: null
    },
    registrationRequired: false,
    registrationError: '',
    registrationSuccess: false,
};

const getters: GetterTree<State, RootState> = {
    isRefresh: (state: State) => state.isRefresh,
    registrationRequired: (state: State) => state.registrationRequired,
    registrationError: (state: State) => state.registrationError,
    registrationSuccess: (state: State) => state.registrationSuccess,
    isAuthenticated: (state: State) => {
        return !!(state.tokens.refresh_token && state.tokens.access_token)
    },
}

const mutations: MutationTree<State> = {
    isRefreshClear(state: State) {
        state.registrationRequired = false
    },
    setRegistrationRequired(state: State, payload: boolean) {
        state.registrationRequired = payload
    },
    setRegistrationError(state: State, payload: string) {
        state.registrationError = payload
    },
    setRegistrationSuccess(state: State, payload: boolean) {
        state.registrationSuccess = payload
    },
    tokenSetup(state: State, newTokens: Tokens) {
        if (newTokens.access_token && newTokens.refresh_token) {
            localStorage.setItem('access-token', newTokens.access_token)
            localStorage.setItem('refresh-token', newTokens.refresh_token)
            state.tokens.access_token = newTokens.access_token
            state.tokens.refresh_token = newTokens.refresh_token
            Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + newTokens.access_token
        }
    },
    clear(state: State) {
        state.tokens.access_token = null
        state.tokens.refresh_token = null
        delete Vue.axios.defaults.headers.common['Authorization']
        localStorage.removeItem('access-token')
        localStorage.removeItem('refresh-token')
        localStorage.removeItem('workspace')
        localStorage.removeItem('lfs-email')
        // localStorage.removeItem('lfs-country')
        localStorage.removeItem('lfs-phone')
        // localStorage.removeItem('lfs-code')
        // localStorage.removeItem('region')
        localStorage.removeItem('show-alert-statistic')
        router.push({name: 'NewAuth'}).catch(() => {})
    }
}

const actions: ActionTree<State, RootState> = {
    async getRegistrationRequired({commit, state}, payload: any) {
        try {
            const {data} = await api.go('checkLogin', {body: payload})
            commit('setRegistrationRequired', data.data.registrationRequired)
        } catch (e) {
        }
    },
    async getConfirmCode({commit, state}, payload) {
        try {
            const {data} = await api.go('confirmCode', {body: payload})
        } catch (e) {
        }
    },
    async signUp({commit, state}, payload) {
        try {
            const {data} = await api.go('signUp', {body: payload})
            let access_token = data.data.access
            let refresh_token = data.data.refresh
            localStorage.setItem('access-token', access_token)
            localStorage.setItem('refresh-token', refresh_token)
            commit('tokenSetup', {access_token, refresh_token})
            if (data.data.access && data.data.refresh) commit('setRegistrationSuccess', true)
            return true
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t(`auth.error.${e.response.data.error}`)]
            })
            commit('setRegistrationError', e.response.data.error)
            return false
        }
    },
    async logIn({commit, state}, payload) {

        return new Promise((resolve, reject) => {
            localStorage.removeItem('access-token')
            localStorage.removeItem('refresh-token')
            api.go('Login', {body: payload})
                .then((resp: any) => {
                    if (resp.data.data.access && resp.data.data.refresh) {
                        let access_token = resp.data.data.access
                        let refresh_token = resp.data.data.refresh
                        localStorage.setItem('access-token', access_token)
                        localStorage.setItem('refresh-token', refresh_token)
                        commit('tokenSetup', {access_token, refresh_token})

                        resolve({
                            access_token: resp.data.access,
                            refresh_token: resp.data.refresh,
                            data: resp.data
                        })
                    } else {
                        reject(resp)
                    }
                })
                .catch((err: any) => {
                    localStorage.removeItem('access-token')
                    localStorage.removeItem('refresh-token')
                    reject(err)
                })
        })

    },
    restoreFromLS({commit}) {
        return new Promise((resolve, reject) => {
            const access_token = localStorage.getItem('access-token')
            const refresh_token = localStorage.getItem('refresh-token')

            if (access_token && refresh_token) {
                commit('tokenSetup', {access_token, refresh_token})
                resolve({access_token, refresh_token})
            } else {
                localStorage.removeItem('access-token')
                localStorage.removeItem('refresh-token')
                reject()
            }
        })
    },
    logout({commit}) {
        commit('clear')
        this.commit('profile/clear')
        this.commit('profile/setUserInvites', null)
    },
    refreshToken({commit, state},) {
        try {
            return state.isRefresh = api.go('refreshToken', {body: {refresh: state.tokens.refresh_token}})
        } catch (e) {

        }
    },
}

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
}
